import React, { useEffect, useState } from 'react';
import { Box, FormGroup, FormControlLabel, Switch, Stack } from '@mui/material';
import {
  updateNotificationState,
  notifications
} from './helper';
import CustomBtnFilled from '../../../../atoms/form-molecules/CustomBtnFilled';

interface ViewAgendaProps {
  projectId: string | null
  onClose: () => void;
}

const ManageProjectNotification: React.FC<ViewAgendaProps> = ({ onClose, projectId }) => {
  const [notificationState, setNotificationState] = useState<notifications>({
    status: false,
    loading: false,
    message: '',
  });

  const handleTrigger = () => {
    updateNotificationState(true, setNotificationState, projectId);
  };

  return (
    <Box
      padding="20px 10px"
      gap={1}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: '200px',
      }}
    >
      <p
        style={{
          fontSize: 16,
          fontWeight: 300,
          fontFamily: 'Montserrat',
          color: '#ff285f',
        }}
      >
        * placeholder caution message
      </p>
      <Stack direction={"column"} spacing={1} alignItems={"center"} gap={2} >
        <CustomBtnFilled
          disabled={notificationState.status}
          variant="contained"
          styles={{
            fontSize: 15,
            fontWeight: 300,
            fontFamily: 'Montserrat',
            maxWidth: '200px'
          }}
          onClick={handleTrigger}
          label="Trigger Notifications"
        />
        <p
          style={{
            minHeight: 15,
            fontSize: 16,
            fontWeight: 300,
            fontFamily: 'Montserrat',
          }}
        >
          {notificationState.message}
        </p>        
      </Stack>
    </Box>
  );
};

export default ManageProjectNotification;
